import script from "./Incident.vue?vue&type=script&setup=true&lang=js"
export * from "./Incident.vue?vue&type=script&setup=true&lang=js"

import "./Incident.vue?vue&type=style&index=0&id=1578ea62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1578ea62"]])

export default __exports__